module.exports = __webpack_public_path__ + "static/te_preview-4312f6e42ae007a33098b46573480275.jpg";